<template>
  <div>
    <layout-head :navActive="4"></layout-head>
    <div class="pictorial_matter_container">
      <div class="warp12">
        <div class="search_container">
          <el-input v-model.trim="searText" placeholder="搜索你想知道的" @keyup.enter.native="checkList"></el-input>
          <img src="@/assets/image/index/search_btn.png" alt class="search_btn" @click="checkList" />
        </div>
        <div class="blue_title white_title">
          <h2><span :class="type ===1?'active':''" @click="changeType(1)">最新推荐</span> / <span :class="type ===2?'active':''" @click="changeType(2)">最热榜单</span></h2>
          <a class="blue_title_more" @click="goTopicList2('new')" v-if="type ===1 ">查看更多 +</a>
          <a class="blue_title_more" @click="goTopicList2('hot')" v-if="type ===2 ">查看更多 +</a>
        </div>
        <div class="new_hot">
          <div class="nh_l" @click="goDetails(leftObj.fileID)">
            <img :src="leftObj.coverUrl" class="nh_l_img" alt />
            <div class="nh_l_tip" :title="leftObj.fileName">{{leftObj.fileName}}</div>
          </div>
          <div class="nh_r">
            <div v-for="(item,index) in list" :key="index" class="nh_r_item_out">
              <div class="nh_r_item" @click="goDetails(item.fileID)" v-if="index>0">
                <img :src="item.coverUrl" class="nh_r_item_img" alt/>
                <div class="nh_r_tip" v-if="index>0" :title="item.fileName">{{item.fileName}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="theme_container">
          <div class="blue_title">
            <h2>专题推荐</h2>
            <a class="blue_title_more" @click="goTopicList('全部')">查看更多 +</a>
          </div>
          <div class="theme_list">
            <div
              v-for="(item,index) in themeList"
              :key="index"
              class="theme_item"
              @click="goTopicList(item)"
            >
            <img :src="require('@/assets/image/multimedia/img'+Number(index+1)+'.png')" class="theme_img" alt />
            <div class="theme_tip">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import layoutHead from '@/components/Header'
import layoutFooter from '@/components/Footer'
import { getData, getTypeData } from '@/assets/js/api'
export default {
  name: 'pictorialMatterPage',
  components: { layoutHead, layoutFooter },
  data () {
    return {
      searText: '',
      themeList: [],
      list: [],
      leftObj: {},
      type: 1,
      code: '002'
    }
  },
  created () {
    this.changeType(1)
    this.getTypeList()
  },
  methods: {
    goTopicList (item) {
      this.$router.push({
        name: 'topic',
        query: {
          item: item,
          code: this.code
        }
      })
    },
    goTopicList2 (type) {
      this.$router.push({
        name: 'topic',
        query: {
          type: type,
          code: this.code
        }
      })
    },
    goDetails (id) {
      this.$router.push({
        name: 'topicDetails',
        query: {
          id: id,
          code: this.code
        }
      })
    },
    changeType (index) {
      this.type = index
      // eslint-disable-next-line prefer-const
      let params = {
        code: '002',
        size: 5
      }
      if (index === 1) {
        params.orderBy = 'updateTime'
      } else if (index === 2) {
        params.orderBy = 'visitCount'
      }

      getData(params).then((res) => {
        if (res.code === '200') {
          this.list = res.content.data
          this.leftObj = res.content.data[0]
        }
      })
    },
    getTypeList () {
      getTypeData({ code: '002' }).then((res) => {
        if (res.code === '200') {
          this.themeList = res.content
        }
      })
    },
    checkList () {
      this.$router.push({
        name: 'topic',
        query: {
          item: '全部',
          code: this.code,
          searText: this.searText
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pictorial_matter_container {
  margin-top: -387px;
  position: relative;
  .search_container {
    margin-bottom: 45px;
  }

  .white_title {
    span {
      cursor: pointer;
      &.active {
        color: #FFCC1B;
      }
    }
  }

  .new_hot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 82px;

    .nh_l {
      width: 600px;
      height: 312px;
      background: #eff1f8;
      padding: 2px;
      box-shadow: 0px 4px 10px 0px rgba(8, 38, 88, 0.18);
      position: relative;
      cursor: pointer;

      .nh_l_img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .nh_l_tip {
        width: 596px;
        height: 47px;
        line-height: 47px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 2px;
        left: 2px;
        font-size: 16px;
        padding: 0 26px;
        color: #f5faff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .nh_r {
      display: flex;
      flex-wrap: wrap;
      width: 564px;
      .nh_r_item_out {

        margin-bottom: 21px;
        &:nth-child(2) {
        margin-right: 20px;
        }
        &:nth-child(4) {
        margin-right: 20px;
        }

        &:nth-child(4),
        &:nth-child(5) {
          margin-bottom: 0;
        }
      }

      .nh_r_item {
        width: 272px;
        height: 144px;
        background: #eff1f8;
        padding: 2px;
        box-shadow: 0px 4px 10px 0px rgba(8, 38, 88, 0.18);
        position: relative;
        cursor: pointer;

        .nh_r_item_img {
          display: block;
          width: 100%;
          height: 100%;
        }

        .nh_r_tip {
          width: 268px;
          height: 35px;
          line-height: 35px;
          background: rgba(0, 0, 0, 0.5);
          position: absolute;
          bottom: 2px;
          left: 2px;
          font-size: 13px;
          padding: 0 20px;
          color: #f5faff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
